import React, { useState } from 'react'
import SignUpSelectionimg from '../../Assets/LoginSelection.png'
import Navbar from '../../Components/Navbar'
import { useNavigate } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import SignupImage from '../../Assets/Signup.png'

function SelectProfessionalTypeSignUp() {
  const navigate = useNavigate()

  const [open, setOpen] = useState(false);

  const options = [
    { label: "Contractor", value: "/ph-ContractorSignUp" },
    { label: "Supplier", value: "/ph-SupplierSignUp" },
    { label: "Freelance Engineer", value: "/ph-FreelancerSignUp" },
    { label: "Architect/Consultants", value: "/ph-LabourSignUp" },
  ];

  return (
    <>
      <Navbar />
      <div className="flex min-h-screen bg-white">
        <div className="hidden md:flex w-1/2 items-center justify-center p-6 bg-gray-50">
          <img
            src={SignupImage}
            alt="illustration"
            className="max-w-md w-full h-[90vh] object-fill"
          />
        </div>

        <div className="flex w-full md:w-1/2 items-center justify-center px-6">
          <div className="max-w-sm w-full">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold">
                Select <span className="text-blue-600">Professional Type</span>
              </h1>
              <p className="text-gray-600 text-sm mt-2 mb-8">
                Find real projects to work on.
              </p>
            </div>
            <div className="relative w-full max-w-md mx-auto">
              <button
                onClick={() => setOpen(!open)}
                className="w-full py-3 px-4 rounded-lg text-white font-medium bg-gradient-to-r from-blue-500 to-red-500 flex justify-between items-center hover:opacity-90 transition"
              >
                Choose your category
                <ChevronDown className={`transition ${open ? "rotate-180" : ""}`} />
              </button>
              {open && (
                <div className="absolute z-20 mt-2 w-full bg-white rounded-lg shadow-lg border border-gray-200">
                  {options.map((opt, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        navigate(opt.value);
                        setOpen(false);
                      }}
                      className="px-4 py-3 text-gray-700 cursor-pointer hover:bg-gray-100 transition"
                    >
                      {opt.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectProfessionalTypeSignUp

